"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getUser = exports.authenticatedFetch = exports.logout = exports.endSession = exports.login = exports.buildAPIURL = exports.init = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var BOOKMARK_URL = 'bookmark_url';
var USER_STORAGE_NAME = 'user';
var apiDomainTestRegex = /^.+\.[^.]+\.[^.]+$/;
var matchServiceRegex = /^([^.]+)/;
var pathStyle;
var onSingleLogout;

var init = function init() {
  var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {}; // if config.pathStyle is defined, assume the
  // user knows what they're doing

  if (typeof config.pathStyle === 'boolean') {
    pathStyle = config.pathStyle;
  } // otherwise, see if the host would be compatible
  // (e.g. something like reporting.inmoment.com) and
  // if not, assume it's a path-style API (e.g. localhost/api)
  else {
      var _location = location,
          hostname = _location.hostname; // to-do: simplify this test by splitting hostname by '.'
      // and then checking that the resulting array has length
      // greater than 2.

      pathStyle = !apiDomainTestRegex.test(hostname);
    }

  if (typeof config.onSingleLogout === 'function') {
    onSingleLogout = config.onSingleLogout;
    addEventListener('storage', handleSingleLogout, false);
  }
};

exports.init = init;

var buildAPIURL = function buildAPIURL() {
  var path = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

  if (typeof pathStyle !== 'boolean') {
    throw new Error('Module not initialized');
  }

  var _location2 = location,
      protocol = _location2.protocol;
  var _location3 = location,
      host = _location3.host;

  if (!path.startsWith('/')) {
    path = '/' + path;
  }

  if (pathStyle) {
    host = host + '/api';
  } else {
    host = host.replace(matchServiceRegex, '$1-api');
  }

  return "".concat(protocol, "//").concat(host).concat(path);
};

exports.buildAPIURL = buildAPIURL;

var login = function login() {
  saveBookmarkURL();
  var loginURL = buildAPIURL('/auth/login');
  location.assign(loginURL);
};

exports.login = login;

function handleSingleLogout(e) {
  // if the user data was removed, do whatever was configured to do.
  if (e.key === USER_STORAGE_NAME && !e.newValue) {
    onSingleLogout();
  }
}

var endSession = /*#__PURE__*/function () {
  var _ref = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee() {
    return _regenerator["default"].wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.prev = 0;
            _context.next = 3;
            return authenticatedFetch('/auth/end_session', {
              headers: {
                'Accept': 'application/json'
              }
            }, false);

          case 3:
            _context.next = 7;
            break;

          case 5:
            _context.prev = 5;
            _context.t0 = _context["catch"](0);

          case 7:
            // remove the user data to trigger single logout in other tabs.
            localStorage.removeItem(USER_STORAGE_NAME);

          case 8:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[0, 5]]);
  }));

  return function endSession() {
    return _ref.apply(this, arguments);
  };
}();

exports.endSession = endSession;

var logout = /*#__PURE__*/function () {
  var _ref2 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee2() {
    var manual,
        logoutURL,
        redirectUrl,
        response,
        _ref3,
        _args2 = arguments;

    return _regenerator["default"].wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            manual = _args2.length > 0 && _args2[0] !== undefined ? _args2[0] : false; // don't respond to single logout anymore since we are manually logging out.

            removeEventListener('storage', handleSingleLogout, false);
            localStorage.removeItem(USER_STORAGE_NAME);
            logoutURL = '/auth/logout';

            if (manual) {
              _context2.next = 7;
              break;
            }

            location.assign(buildAPIURL(logoutURL));
            return _context2.abrupt("return", undefined);

          case 7:
            redirectUrl = undefined;
            _context2.prev = 8;
            _context2.next = 11;
            return authenticatedFetch(logoutURL, {
              headers: {
                'Accept': 'application/json'
              }
            }, false);

          case 11:
            response = _context2.sent;
            _context2.next = 14;
            return response.json();

          case 14:
            _ref3 = _context2.sent;
            redirectUrl = _ref3.redirectUrl;
            _context2.next = 20;
            break;

          case 18:
            _context2.prev = 18;
            _context2.t0 = _context2["catch"](8);

          case 20:
            return _context2.abrupt("return", redirectUrl);

          case 21:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2, null, [[8, 18]]);
  }));

  return function logout() {
    return _ref2.apply(this, arguments);
  };
}();

exports.logout = logout;

var authenticatedFetch = /*#__PURE__*/function () {
  var _ref4 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee3(path) {
    var options,
        redirect,
        requestUrl,
        response,
        _args3 = arguments;
    return _regenerator["default"].wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            options = _args3.length > 1 && _args3[1] !== undefined ? _args3[1] : {};
            redirect = _args3.length > 2 && _args3[2] !== undefined ? _args3[2] : true;

            if (typeof options === 'boolean') {
              redirect = options;
              options = {};
            }

            requestUrl = buildAPIURL(path);
            options = Object.assign({}, options, {
              credentials: 'include'
            });
            _context3.prev = 5;
            _context3.next = 8;
            return fetch(requestUrl, options);

          case 8:
            response = _context3.sent;

            if (!(redirect && response.status === 401)) {
              _context3.next = 14;
              break;
            }

            login();
            return _context3.abrupt("return", undefined);

          case 14:
            return _context3.abrupt("return", response);

          case 15:
            _context3.next = 20;
            break;

          case 17:
            _context3.prev = 17;
            _context3.t0 = _context3["catch"](5);
            return _context3.abrupt("return", undefined);

          case 20:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3, null, [[5, 17]]);
  }));

  return function authenticatedFetch(_x) {
    return _ref4.apply(this, arguments);
  };
}();

exports.authenticatedFetch = authenticatedFetch;

var getUser = /*#__PURE__*/function () {
  var _ref5 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee4() {
    var response, now, user;
    return _regenerator["default"].wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            _context4.next = 2;
            return authenticatedFetch('/auth/user', {
              headers: {
                'Accept': 'application/json'
              }
            }, false);

          case 2:
            response = _context4.sent;

            if (!(response && response.status < 300)) {
              _context4.next = 13;
              break;
            }

            now = Math.floor(Date.now() / 1000);
            _context4.next = 7;
            return response.json();

          case 7:
            user = _context4.sent;

            if (!(!user || user.expires <= now)) {
              _context4.next = 10;
              break;
            }

            return _context4.abrupt("return", undefined);

          case 10:
            storeUser(user);
            checkBookmarkURL();
            return _context4.abrupt("return", user);

          case 13:
            return _context4.abrupt("return", undefined);

          case 14:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4);
  }));

  return function getUser() {
    return _ref5.apply(this, arguments);
  };
}();

exports.getUser = getUser;

function saveBookmarkURL() {
  if (location.href !== "".concat(location.protocol, "//").concat(location.host)) {
    var bookmarkUrl = {
      'bookmark': location.href.replace(location.origin, '')
    };

    try {
      localStorage.setItem(BOOKMARK_URL, JSON.stringify(bookmarkUrl));
    } catch (err) {// error storing bookmark URL
    }
  }
}

function checkBookmarkURL() {
  var bookmarkUrl = localStorage.getItem(BOOKMARK_URL);

  if (bookmarkUrl) {
    bookmarkUrl = JSON.parse(bookmarkUrl);
    localStorage.removeItem(BOOKMARK_URL);

    if (bookmarkUrl.bookmark) {
      location.assign(bookmarkUrl.bookmark);
    }
  }
}

function storeUser(user) {
  if (!user) {
    return;
  }

  try {
    localStorage.setItem(USER_STORAGE_NAME, JSON.stringify(user));
  } catch (err) {
    // error storing user info
    return;
  }
}